import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Output, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { RegistrationStep } from '@core/models/common.interface';
import { environment } from '@env/environment';
import { CancelButton } from '@shared/components/cancel-button/cancel-button';
import { PrimaryButtonComponent } from '@shared/components/primary-button/pirmary-button.component';
import { Spacer } from '@shared/components/spacer/spacer';
import { TsAndCsBottomSheetComponent } from '@shared/components/ts-and-cs-bottom-sheet/ts-and-cs-bottom-sheet.component';

@Component({
  selector: 'app-terms-and-conditions',
  imports: [
    CommonModule,
    PrimaryButtonComponent,
    Spacer,
    MatIconModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    CancelButton,
  ],
  templateUrl: './terms-and-conditions.html',
  styleUrl: './terms-and-conditions.scss',
  standalone: true,
})
export class TermsAndConditions {
  @Output() continue = new EventEmitter<RegistrationStep>();
  termsAccepted = signal(false);
  protected readonly environment = environment;
  private _bottomSheet = inject(MatBottomSheet);

  constructor(private fb: FormBuilder) {}

  openBottomSheet(): void {
    this._bottomSheet.open(TsAndCsBottomSheetComponent, {
      panelClass: 'custom-bottom-sheet',
    });
  }

  nextStep(): void {
    this.continue.emit(RegistrationStep.personalDetails);
  }
}
